module.exports = __webpack_public_path__ + "img/InviteFriends.6f4b6101_6f4b610116e84db9c8e5d19fe90fa5e8.6f4b6101.svg";